import React, { useMemo } from 'react';
import DataTable from 'components/DataTable';
import styles from './index.module.scss';
import { tableStyles } from 'css/tableStyles';
import CustomLink from 'components/TableLink';
import { DATE_FORMATS, ORDER_STATUS, formatDate } from 'utils';

const OrderTimeline = props => {
  const { events } = props;
  const columns = useMemo(() => [
    {
      name: 'By User',
      selector: 'by',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <CustomLink
          text={row?.by?.id || '-'}
          linkTo={`/users/${row?.by?.id}`}
        />
      ),
    },
    {
      name: 'Status',
      selector: 'eventName',
    },
    {
      name: 'Date',
      selector: 'timestamp',
      sortable: true,
      format: row => formatDate(row.timestamp, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
    },
  ], []);

  return (
    <div className={styles['order-timeline-details-section']}>
      <div className={styles['subheading']}>Order Timeline</div>
      <div className={styles['table-container']}>
        <DataTable
          noHeader={true}
          columns={columns}
          defaultSortField={'timestamp'}
          customStyles={tableStyles}
          data={events}
          defaultSortAsc={false}
        />
      </div>
    </div>
  );
};

export default OrderTimeline;